import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from 'semantic-ui-react';
import { getFooterHTML, getSystemName } from '../helpers';
import globalStyles from '../styles/globalStyles';

const Footer = () => {
  const { t } = useTranslation();
  const systemName = getSystemName();
  const [footer, setFooter] = useState(getFooterHTML());
  let remainCheckTimes = 5;

  const loadFooter = () => {
    let footer_html = localStorage.getItem('footer_html');
    if (footer_html) {
      setFooter(footer_html);
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      if (remainCheckTimes <= 0) {
        clearInterval(timer);
        return;
      }
      remainCheckTimes--;
      loadFooter();
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={globalStyles.footer}>
      <Container textAlign='center' style={{ color: '#6b7280', fontSize: 13 }}>
        {footer ? (
          <div
            className='custom-footer'
            dangerouslySetInnerHTML={{ __html: footer }}
          ></div>
        ) : (
          <div className='custom-footer'>
            {systemName} {process.env.REACT_APP_VERSION}
          </div>
        )}
      </Container>
    </div>
  );
};

export default Footer;
